module.exports = __webpack_public_path__ + "static/media/emoji-people.cd6b01c2.svg";